<template>
  <table>
    <tr>
      <th style="text-align: center">
        Lager
      </th>
      <th style="text-align: center">
        Ausgewählt
      </th>
    </tr>
    <tr>
      <td style=" vertical-align:top;width: 50%">
        <SogCardActions
          v-for="insurance in _store"
          :key="insurance"
          :is-toolbar="true"
        >
          <SogCardActionButton @click="onAdd(insurance)">
            {{ insurance.insuranceNumber }}<br>{{ insurance.evb }}
          </SogCardActionButton>
        </SogCardActions>
      </td>
      <td style=" vertical-align:top">
        <SogCardActions
          v-for="insurance in _shoppingCartStore.getCurrentItem().shoppingCartItem.insurances"
          :key="insurance"
          :is-toolbar="true"

          style="justify-content: flex-start; align-items: start"
        >
          <SogCardActionButton @click="onRemove(insurance)">
            {{ insurance.insuranceNumber }}<br>{{ insurance.evb }}
          </SogCardActionButton>
        </SogCardActions>
      </td>
    </tr>
  </table>
</template>

<script setup lang="ts">
import {  ref, watch } from "vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import Insurance, {sortInsuranceByNumber} from "@/shared/model/Insurance";

interface Props {
  insurances:Insurance[],
}

const props = defineProps<Props>()



const _shoppingCartStore = useShoppingCartStore();
const _store = ref<Insurance[]>([])

function onAdd(insurance: Insurance) {
  _shoppingCartStore.addInsurance(insurance)
  _store.value = _store.value.filter(t=>t.id!=insurance.id)
}
function onRemove(insurance: Insurance) {
  _shoppingCartStore.removeInsurance(insurance)
  _store.value = sortInsuranceByNumber([..._store.value,insurance])
}

watch((props),()=>{
  _store.value=[...props.insurances]
},{immediate:true})

</script>

<style>

</style>
